module.exports = __webpack_public_path__ + "static/media/switch-default-v2.f75268e1.svg";